<template>
  <div>
    <!-- Snackbar -->
    <v-snackbar
      :value="snackbar"
      @input="$emit('update:snackbar', $event)"
      :timeout="3000"
      top
      right
      :color="snackbarColor || 'success'"
      rounded="pill"
    >
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn icon v-bind="attrs" @click="$emit('update:snackbar', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>

    <DialogAdjuntosArchivo
      :dialog="attachDialog"
      @update:dialog="$emit('update:attachDialog', $event)"
      :nodoName="nodoSeleccionadoParaAdjunto?.name"
      :carpetas="carpetasParaAdjunto"
      :carpetaInicial="carpetaParaAdjunto"
      requiere-carpeta
      @upload="$emit('upload', $event)"
    />

    <DialogCrearSubnodo
      :nodoEditando="nodoEditando"
      :dialog="crearSubnodoDialog"
      :nodoParaCrearHijo="nodoParaCrearHijo"
      @update:dialog="$emit('update:crearSubnodoDialog', $event)"
      :tiposNodo="tiposNodo"
      :bannerTipoSeleccionado="bannerTipoSeleccionado"
      @save-subnode="$emit('save-subnode', $event)"
    />

    <DialogEditarNodo
      :dialog="editarNodoDialog"
      @update:dialog="$emit('update:editarNodoDialog', $event)"
      :nodoEditando="nodoEditando"
      :tiposNodo="tiposNodo"
      @crear-nuevo-tipo="$emit('crear-nuevo-tipo')"
      @guardar-edicion="$emit('guardar-edicion')"
    />

    <AdjuntosLista
      v-if="selectedAdjuntos"
      :dialog="selectedAdjuntos !== null"
      @close="$emit('close-adjuntos')"
      @refresh-adjuntos="$emit('refresh-adjuntos')"
      @add-adjunto="$emit('add-adjunto', $event)"
      @ver-en-plano="$emit('ver-en-plano', $event)"
      @ver-en-arbol="$emit('ver-en-arbol', $event)"
      
      :adjuntos="adjuntos"
      :articulos="articulos"
      :region="selectedAdjuntos"

      :verPlanos="verPlanos"
      :puedeEditar="puedeEditar"

      :puedeAdjuntar="puedeAdjuntar"
      :puedeEliminar="puedeEliminar"
      :bloqueado="bloqueado"
    />

    <DialogPlano
      :planoYposicion="planoYposicion"
      :dialogPlanos="dialogPlanos"
      :nodo="selectedPlano"
      @cerrar="$emit('cerrar-planos')"
      @select="$emit('select', $event)"
      @ir-a-subplano="$emit('ir-a-subplano', $event)"
      @add-adjunto="$emit('add-adjunto', $event)"
      @ver-en-arbol="$emit('ver-en-arbol', $event)"
      @ver-en-plano="$emit('ver-en-plano', $event)"
    />

    <DialogListaArmarios
      :dialogSeleccionarArmario="dialogSeleccionarArmario"
      :armarios="armarios"
      :nodo="nodoParaCrearHijo"
      @fetch="$emit('fetch')"
      @select-armario-para-region="$emit('select-armario-para-region', $event)"
      @abrir-dialog-crear-subnodo="$emit('abrir-dialog-crear-subnodo', $event)"
      @cambiar-estado-dialog="$emit('cambiar-estado-dialog', $event)"
      @cambiar-padre-de-armario="$emit('cambiar-padre-de-armario',$event)"
    />

    <!-- Scanner -->
    <v-dialog :value="showScanner" @input="$emit('update:showScanner', $event)" max-width="500px" persistent>
      <v-card>
        <v-card-title class="primary white--text">
          Escanear Código QR
          <v-spacer />
          <v-btn icon dark @click="$emit('update:showScanner', false)">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pa-0">
          <qrcode-stream v-if="showScanner" @decode="$emit('decode', $event)" />
        </v-card-text>

        <v-card-actions class="justify-center pa-4">
          <p class="grey--text mb-0">Encuadre el código QR del armario para ver su información</p>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Ver QR -->
    <v-dialog :value="dialogVerQR" @input="$emit('update:dialogVerQR', $event)" max-width="350">
      <v-card v-if="nodoParaQR" class="text-center pa-4">
        <v-card-title class="justify-center">QR de: {{ nodoParaQR.name }}</v-card-title>

        <v-card-text class="d-flex justify-center">
          <div id="print-section" class="pa-4 white">
            <qrcode-vue :value="generarUrlParaQR(nodoParaQR.qr_code)" :size="200" level="H" />
            <!-- código del armario en la intranet; solo ese texto sale al imprimir -->
            <div v-if="nodoParaQR.codigo_intranet" class="mt-2 font-weight-black codigo-qr">{{ nodoParaQR.codigo_intranet }}</div>
            <div v-else class="mt-2 caption grey--text font-italic">Creado desde el portal (sin código de intranet)</div>
          </div>
        </v-card-text>

        <v-card-actions>
          <v-btn color="primary" block outlined @click="$emit('imprimir-qr')">
            <v-icon left>mdi-printer</v-icon> Imprimir
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Elegir plano -->
    <v-dialog :value="dialogElegirPlano" @input="$emit('update:dialogElegirPlano', $event)" max-width="420" persistent>
      <v-card>
        <v-card-title class="justify-center">
          Selecciona un plano
          <v-spacer />
          <v-btn icon @click="$emit('update:dialogElegirPlano', false)">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <PlanosLista
            :modo="1"
            :planosData="planosData"
            :planoSeleccionado="selectedPlano"
            @select="$emit('select-plano-store', $event)"
            @plano-creado="$emit('plano-creado')"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import DialogAdjuntosArchivo from "../dialogs/DialogAdjuntosArchivo.vue";
import DialogCrearSubnodo from "../dialogs/DialogCrearSubnodo.vue";
import DialogEditarNodo from "../dialogs/DialogEditarNodo.vue";
import DialogPlano from "../dialogs/DialogPlano.vue";
import AdjuntosLista from "../../utils/AdjuntosLista.vue";
import PlanosLista from "../../utils/PlanosLista.vue";
import DialogListaArmarios from "./DialogListaArmarios.vue";

import { QrcodeStream } from "vue-qrcode-reader";
import QrcodeVue from "qrcode.vue";


export default {
  name: "ArmariosDialogs",
  components: {
    DialogAdjuntosArchivo,
    DialogCrearSubnodo,
    DialogEditarNodo,
    DialogPlano,
    DialogListaArmarios,
    AdjuntosLista,
    PlanosLista,
    QrcodeStream,
    QrcodeVue,
  },
  props: {
    snackbar: { type: Boolean, default: false },
    snackbarText: { type: String, default: "" },
    snackbarColor: { type: String, default: null },

    attachDialog: { type: Boolean, default: false },
    crearSubnodoDialog: { type: Boolean, default: false },
    editarNodoDialog: { type: Boolean, default: false },
    dialogPlanos: { type: Boolean, default: false },
    dialogElegirPlano: { type: Boolean, default: false },

    showScanner: { type: Boolean, default: false },
    dialogVerQR: { type: Boolean, default: false },
    nodoParaQR: { type: Object, default: null },

    nodoSeleccionadoParaAdjunto: { type: Object, default: null },
    tiposNodo: { type: Array, default: () => [] },
    bannerTipoSeleccionado: { type: String, default: null },
    nodoEditando: { type: Object, default: () => ({}) },

    selectedAdjuntos: { type: Object, default: null },
    // carpetas del armario al que se adjunta y la elegida
    carpetasParaAdjunto: { type: Array, default: () => [] },
    carpetaParaAdjunto: { type: [Number, String], default: null },
    adjuntos: { type: Array, default: () => [] },
    articulos: { type: Array, defualt: () => [] },

    planoYposicion: { type: Object, default: () => ({}) },
    selectedPlano: { type: [Object, Number, String], default: null },
    planosData: { type: Array, default: () => [] },
    nodoParaCrearHijo: { type: Object, default: null },

    armarios: { type: Array, default: () => [] },
    dialogSeleccionarArmario: { type: Boolean, default: false },

    verPlanos: {type: Boolean, default: true},
    puedeEditar: {type: Boolean, default: true},

    puedeAdjuntar: {type: Boolean, default: true},
    puedeEliminar: {type: Boolean, default: true},
    bloqueado: {type: Boolean, default: false},
  },
  methods: {
    generarUrlParaQR(qrCode) {
      const path = window.location.pathname;
      return `${window.location.origin}${path}?qr=${qrCode}`;
    },
  },
};
</script>